import { TweenLite, Power3 } from 'gsap/TweenMax';
import contains from 'contains';

import ScrollMagic from 'scrollmagic';
import { controller } from '@/components/_scrollmagic';
import breakpoints from '@/scripts/utils/breakpoints';
import { DOCUMENT_ELEMENT } from '@/scripts/constants';
import toggleModal from '@/scripts/utils/toggle-modal';
import clickOutside from 'click-outside';

export default function initNavigation() {
  const anchorLinks = '[href^="#"]';
  const sections = '[data-role*="section"]';
  const activeClass = 'is-active';
  const openedClass = 'menu-opened';

  const nav = document.querySelector('[data-role="nav"]');
  const navItem = document.querySelector('[data-role="nav-item"]');
  if (!nav) return;
  const navScroll = '[data-role="nav-scroll"]';
  const $navScroll = $(navScroll);

  const trigger = document.querySelector('[data-role="menu-trigger"]');


  let scrolling = false;

  const toggle = (allow) => {
    if (document.innerHeight <= breakpoints.lg) {
      DOCUMENT_ELEMENT.classList.toggle(openedClass, allow);
      toggleModal(DOCUMENT_ELEMENT.classList.contains(openedClass), navScroll, nav);
    }
  };

  trigger.addEventListener('click', () => {
    toggle(!DOCUMENT_ELEMENT.classList.contains(openedClass));
  });

  clickOutside(nav, (e) => {
    if (DOCUMENT_ELEMENT.classList.contains(openedClass) && !contains(e.target, trigger)) {
      toggle(false);
    }
  });

  const changeActiveLink = (newLink, force) => {
    if (contains(nav, newLink)) {
      if (scrolling && !force) {
        return;
      }
      const activeLink = nav.querySelector(`${anchorLinks}.${activeClass}`);
      if (activeLink) {
        navItem.classList.remove(activeClass);
        activeLink.classList.remove(activeClass);
      }
      newLink.classList.add(activeClass);
      const offset = $navScroll.scrollTop() + $(newLink).offset().top - $(window).scrollTop() - 200;
      TweenLite.to($navScroll, 1.2, { scrollTo: { y: offset, autoKill: false, ease: Power3.easeInOut } });
      if (window.history.pushState) {
        window.history.pushState(null, null, newLink.hash);
      }
    }
  };
  document.querySelectorAll(anchorLinks).forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      changeActiveLink(link, true);
      toggle(false);
      scrolling = true;
      const offset = $(link.hash).offset().top;
      TweenLite.to(window, 1.2, { scrollTo: { y: offset, autoKill: false, ease: Power3.easeInOut }, onComplete() { scrolling = false; } });
    });
  });

  document.querySelectorAll(sections).forEach(section => new ScrollMagic.Scene({
    triggerElement: section,
    duration: section.offsetHeight,
  })
    .on('enter', () => {
      changeActiveLink(document.querySelector(`[href*="#${section.id}"]`));
    })
    .addTo(controller));

  // $(document).ready(() => {
  //   $(window).scroll(() => {
  //     const docScrollTop = $(window).scrollTop();
  //     // console.log(docScrollTop);
  //     if (docScrollTop > 2000 && docScrollTop < 7100) {
  //       $(nav).css({ transform: 'none', opacity: 1, transition: 'transform $duration $easing, opacity duration_long $easing' });
  //     } else {
  //       $(nav).css({ transform: 'translateX(-100%)', opacity: 0, transition: 'transform $duration $easing, opacity duration_long $easing' });
  //     }
  //   });
  // });

  const showNav = () => {
    $(nav).css({ transform: 'none', opacity: 1 });
  };
  const hideNav = () => {
    $(nav).css({ transform: 'translateX(-100%)', opacity: 0 });
  };
  const hashNav = document.getElementById('hash-nav');
  const revealScene = new ScrollMagic.Scene({
    triggerElement: hashNav,
    triggerHook: 0.5,
  });
  const leaveScene = new ScrollMagic.Scene({
    triggerElement: hashNav.nextElementSibling,
    triggerHook: 0.5,
  });
  revealScene.on('enter', showNav);
  revealScene.on('leave', hideNav);
  leaveScene.on('enter', hideNav);
  leaveScene.on('leave', showNav);
  revealScene.addTo(controller);
  leaveScene.addTo(controller);
}



// WEBPACK FOOTER //
// ./scripts/utils/initNavigation.js